import { Box } from '@mui/material';
import BaseButton from 'core/components/button/BaseButton';
import BaseTypography from 'core/components/typography/BaseTypography';
import { ApiStage } from 'core/constants/enums/ApiStages.ts';
import { SubscriptionPlanType } from 'core/constants/enums/SubscriptionPlanType.ts';
import { planTypeToggleDropDownStyles } from 'core/layouts/components/subscription-plans/components/plan-type-toggle-dropdown/PlanTypeToggleDropDownStyles';
import { reusableStyles } from 'core/layouts/ui-blocks/ReusableStyles';
import {
	getSubscriptionPlansApiStageSelector,
	subscriptionPlansSelector,
} from 'core/store/reducers/profileReducer/ProfileSlice';
import React from 'react';
import { useSelector } from 'react-redux';
import { colorPalette } from 'core/layouts/ui-blocks/ColorPalette';

function PlanTypeToggleDropDown({ tabs, selectedPlanType, setSelectedPlanType }) {
	const subscriptionPlans = useSelector(subscriptionPlansSelector);
	const subscriptionPlansApiStage = useSelector(getSubscriptionPlansApiStageSelector);
	return (
		<>
			{subscriptionPlansApiStage === ApiStage.LOADING && (
				<>
					<Box sx={[planTypeToggleDropDownStyles.planTypeToggle]}>
						<Box
							key="loading-plan-type"
							id="loading-plan-type"
							sx={[
								planTypeToggleDropDownStyles.planTypeTab,
								reusableStyles.skeletonLoaderStyles,
								{
									minHeight: '48px',
									minWidth: '224px',
									borderRadius: '50px',
								},
							]}
						/>
					</Box>

					<BaseButton
						id="plan-type dropdown"
						styles={[planTypeToggleDropDownStyles.planTypeDropdown]}
						disableRipple
					>
						<Box
							key="selected-plan-type"
							id="selected-plan-type"
							sx={[
								planTypeToggleDropDownStyles.planTypeTab,
								reusableStyles.skeletonLoaderStyles,
								{ minHeight: '32px', minWidth: 'unset', width: '100%' },
							]}
						/>
					</BaseButton>
				</>
			)}
			{subscriptionPlansApiStage === ApiStage.SUCCESS && (
				<Box
					sx={[
						reusableStyles.flexRowWithGap(10),
						{ width: '100%', alignItems: 'center', justifyContent: 'center' },
					]}
				>
					<Box sx={[planTypeToggleDropDownStyles.planTypeToggle, { display: 'flex' }]}>
						{tabs.map((tab) => {
							if (subscriptionPlans[tab.value]?.length > 0) {
								return (
									<Box
										key={tab.label}
										id={tab.label}
										sx={[
											planTypeToggleDropDownStyles.planTypeTab,
											{
												backgroundColor:
													selectedPlanType.value === tab.value ? 'colors.dark4' : 'transparent',
												borderRight:
													selectedPlanType.value === SubscriptionPlanType.MONTHLY &&
													`1px solid ${colorPalette.dark2}`,
												borderLeft:
													selectedPlanType.value === SubscriptionPlanType.ANNUALLY &&
													`1px solid ${colorPalette.dark2}`,
												borderRadius: SubscriptionPlanType.MONTHLY
													? '50px'
													: tab.value === SubscriptionPlanType.MONTHLY
														? '50px 0 0 50px'
														: '0 50px 50px 0',
											},
										]}
										onClick={() => setSelectedPlanType(tab)}
									>
										<BaseTypography
											variant="b1_medium"
											styles={{
												color:
													selectedPlanType.value === tab.value ? 'colors.light1' : 'colors.light4',
												whiteSpace: 'nowrap',
												fontSize: { xs: '12px', sm: '14px' },
											}}
										>
											{tab.label}
										</BaseTypography>
									</Box>
								);
							}
							return null;
						})}
					</Box>
				</Box>
			)}
		</>
	);
}

export default PlanTypeToggleDropDown;
